import apiClient from "./axios";
import { API_ENDPOINTS } from "./urls";

export const createAudioSession = async (data) => {
  return apiClient.post(API_ENDPOINTS.SESSION.START, data);
};

export const sendInstantAudio = async (formData) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.SESSION.INSTANT_AUDIO,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response; // Return response for further processing if needed
  } catch (error) {
    console.error("Error sending audio chunk:", error);
    throw error;
  }
};

export const getContentById = async (sessionId) => {
  return apiClient.get(
    API_ENDPOINTS.SESSION.CONTENT.replace(":sessionId", sessionId)
  );
};

export const saveContentById = async ({ sessionId, content }) => {
  return apiClient.patch(
    API_ENDPOINTS.SESSION.CONTENT.replace(":sessionId", sessionId),
    { content }
  );
};

export const fetchSessionCard = async (sessionId) => {
  return apiClient.get(
    API_ENDPOINTS.SESSION.USAGE_CARD.replace(":sessionId", sessionId)
  );
};

export const fetchSessionList = async (sessionId) => {
  return apiClient.get(
    API_ENDPOINTS.SESSION.USAGE_LIST.replace(":sessionId", sessionId)
  );
};

export const uploadRawFileApi = async (formData) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.SESSION.RAW_FILE,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error sending audio chunk:", error);
    throw error;
  }
};

export const notificationList = async () => {
  return apiClient.get(API_ENDPOINTS.NOTIFICATIONS.LIST);
};

export const readById = async (id) => {
  return apiClient.patch(API_ENDPOINTS.NOTIFICATIONS.READ.replace(":id", id));
};

export const deleteSessionByIdApi = async (sessionId) => {
  return apiClient.delete(
    API_ENDPOINTS.SESSION.DELETE.replace(":sessionId", sessionId)
  );
};

export const getAllSession = async (page = 1, limit = 10) => {
  return apiClient.get(`${API_ENDPOINTS.SESSION.ALL}?page=${page}&limit=${limit}`);
};

export const bookMarkSessionApi = async (sessionId) => {
  return apiClient.get(
    API_ENDPOINTS.SESSION.BOOKMARK.replace(":sessionId", sessionId)
  );
};

export const askSessionAI = async (sessionId, query) => {
  return apiClient.post(
    `/v1/session/${sessionId}/ask`,
    { query }
  );
};

export const getUserProfile = async () => {
  return apiClient.get(API_ENDPOINTS.PROFILE.ME);
};

export const getUsageApi = async () => {
  return apiClient.get(API_ENDPOINTS.PROFILE.USAGE);
};

export const getSubscription = async () => {
  return apiClient.get(API_ENDPOINTS.PROFILE.SUBSCRIPTION);
};

export const loginApi = async (data) => {
  return apiClient.post(API_ENDPOINTS.AUTH.LOGIN, data);
};

export const registerApi = async (data) => {
  return apiClient.post(API_ENDPOINTS.AUTH.REGISTER, data);
};

export const createSubscription = async (plan) => {
  return apiClient.post(API_ENDPOINTS.PROFILE.SUBSCRIPTION, { plan });
};

export const exportPdfApi = async (sessionId, fileName = "session-notes") => {
  try {
    const response = await apiClient.get(
      API_ENDPOINTS.EXPORT.ALL.replace(':sessionId', sessionId),
      {
        params: {
          fileName,
          type: 'pdf'
        },
        responseType: 'blob'
      }
    );

    return response;
  } catch (error) {
    console.error('PDF export API error:', error);
    throw error;
  }
};

export const exportDocxApi = async (sessionId, fileName = "session-notes") => {
  try {
    const response = await apiClient.get(
      API_ENDPOINTS.EXPORT.ALL.replace(':sessionId', sessionId),
      {
        params: {
          fileName,
          type: 'docx'
        },
        responseType: 'blob'
      }
    );

    return response;
  } catch (error) {
    console.error('DOCX export API error:', error);
    throw error;
  }
};

export const exportTxtApi = async (sessionId, fileName = "session-notes") => {
  try {
    const response = await apiClient.get(
      API_ENDPOINTS.EXPORT.ALL.replace(':sessionId', sessionId),
      {
        params: {
          fileName,
          type: 'txt'
        },
        responseType: 'blob'
      }
    );

    return response;
  } catch (error) {
    console.error('TXT export API error:', error);
    throw error;
  }
};

export const paymentPhonePeApi = async (amount = 500) => {
  return apiClient.post(API_ENDPOINTS.PAYMENT.CREATE, { amount });
};

export const uploadScreenChunkApi = async (formData) => {
  return apiClient.post(API_ENDPOINTS.VIDEO.SCREEN_UPLOAD, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
